<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/plan-validation-rules" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.EditValidationRule") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.InputPlanId")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.InputPlanId')"
                >
                  <v-select
                    v-if="filteredInputPlans || (DataById && DataById.planList)"
                    label="planDescription"
                    :options="
                      filteredInputPlans
                        ? filteredInputPlans
                        : DataById.planList
                    "
                    v-model="inputPlanId"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    :reduce="(obj) => obj.id"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.CheckinPlanId")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.CheckinPlanId')"
                >
                  <v-select
                    v-if="
                      filteredCheckinPlans || (DataById && DataById.planList)
                    "
                    label="planDescription"
                    :options="
                      filteredCheckinPlans
                        ? filteredCheckinPlans
                        : DataById.planList
                    "
                    v-model="checkinPlanId"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(obj) => obj.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.RuleAppliesTo")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.RuleAppliesTo')"
                >
                  <v-select
                    v-if="DataById && DataById.ruleAppliestoList"
                    label="mCodeValue"
                    :options="DataById.ruleAppliestoList"
                    v-model="ruleAppliesTo"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    :reduce="(obj) => obj.id"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.Rule")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Rule')"
                >
                  <v-select
                    v-if="DataById && DataById.ruleExpressionList"
                    label="mCodeValue"
                    :options="DataById.ruleExpressionList"
                    v-model="rule"
                    :reduce="(obj) => obj.id"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createTeamData"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ValidationPopup from "@/components/ValidationPopup.vue";

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      inputPlanId: "",
      checkinPlanId: "",
      ruleAppliesTo: "",
      rule: "",
      id: "",
    };
  },
  components: {
    "v-select": vSelect,
    "validation-popup": ValidationPopup,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      DataById: (state) => state.planValidationRules.validationRuleById,
    }),
    filteredCheckinPlans() {
      if (this.inputPlanId) {
        return this.DataById.planList.filter(
          (plan) => plan.id !== this.inputPlanId
        );
      }
    },
    filteredInputPlans() {
      if (this.checkinPlanId) {
        return this.DataById.planList.filter(
          (plan) => plan.id !== this.checkinPlanId
        );
      }
    },
  },
  methods: {
    async createTeamData() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        const payload = {
          id: this.id,
          data: {
            inputPlanId: this.inputPlanId,
            checkinPlanId: this.checkinPlanId,
            ruleAppliesTo: this.ruleAppliesTo,
            rule: this.rule,
          },
        };

        await this.$store.dispatch(
          "planValidationRules/editPlanValidationRuleAction",
          payload
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Validation Rule Updated Successfully!",
          type: "success",
        });
        this.$router.push(`/setup/plan-validation-rules`);
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async getDataById() {
      try {
        await this.$store.dispatch(
          "planValidationRules/getPlanValidationRuleByIdAction",
          this.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.inputPlanId = this.DataById.inputPlanId;
      this.checkinPlanId = this.DataById.checkinPlanId;
      this.ruleAppliesTo = this.DataById.ruleAppliesTo;
      this.rule = this.DataById.rule;
    },

    cancel() {
      this.$router.push("/setup/plan-validation-rules");
    },
  },
  watch: {},
  mounted() {
    this.id = this.$route.params.id;
    this.getDataById();
  },
};
</script>
